










import { Component, Vue, Prop } from 'vue-property-decorator'

import AppRouterLink from '@/components/AppRouterLink.vue'

@Component({
  components: {
    AppRouterLink
  }
})
export default class extends Vue {
  @Prop(Array) readonly tabs!: object[]
  @Prop(String) readonly where!: string
}
